import { KEYVALUES_SERVICE } from "@/services/keyValues.service.js";

const state = {getKeyValuesOutput: {}, postKeyValueOutput: false, putKeyValueOutput: false, getKeyValueByIdOutput: {}, deleteKeyValueOutput: false};

const actions = {
    //Service to get key values
    getKeyValues({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getKeyValuesRequest');

        KEYVALUES_SERVICE.getKeyValues(queryParams)
            .then(
                output => {
                    commit('getKeyValuesSuccess', output);
                },
                error => {
                    commit('getKeyValuesFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to create key value
    postKeyValue({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postKeyValueRequest');

        KEYVALUES_SERVICE.postKeyValue(input)
            .then(
                output => {
                    commit('postKeyValueSuccess', output);
                },
                error => {
                    commit('postKeyValueFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update key value
    putKeyValue({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putKeyValueRequest');

        KEYVALUES_SERVICE.putKeyValue(input)
            .then(
                output => {
                    commit('putKeyValueSuccess', output);
                },
                error => {
                    commit('putKeyValueFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get key value details
    getKeyValueById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getKeyValueByIdRequest');

        KEYVALUES_SERVICE.getKeyValueById(id)
            .then(
                output => {
                    commit('getKeyValueByIdSuccess', output);
                },
                error => {
                    commit('getKeyValueByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete key value
    deleteKeyValue({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteKeyValueRequest');

        KEYVALUES_SERVICE.deleteKeyValue(id)
            .then(
                output => {
                    commit('deleteKeyValueSuccess', output);
                },
                error => {
                    commit('deleteKeyValueFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //getKeyValues
    getKeyValuesRequest(state) {
    },
    getKeyValuesSuccess(state, output) {
        state.getKeyValuesOutput = output;
    },
    getKeyValuesFailure(state) {
        state.getKeyValuesOutput = false;
    },

    //postKeyValue
    postKeyValueRequest(state) {
        state.postKeyValueOutput = null;
    },
    postKeyValueSuccess(state, output) {
        state.postKeyValueOutput = true;
    },
    postKeyValueFailure(state) {
        state.postKeyValueOutput = false;
    },

    //putKeyValue
    putKeyValueRequest(state) {
        state.putKeyValueOutput = null;
    },
    putKeyValueSuccess(state, output) {
        state.putKeyValueOutput = true;
    },
    putKeyValueFailure(state) {
        state.putKeyValueOutput = false;
    },

    //getKeyValueById
    getKeyValueByIdRequest(state) {
    },
    getKeyValueByIdSuccess(state, output) {
        state.getKeyValueByIdOutput = output;
    },
    getKeyValueByIdFailure(state) {
        state.getKeyValueByIdOutput = false;
    },

    //deleteKeyValue
    deleteKeyValueRequest(state) {
        state.deleteKeyValueOutput = null;
    },
    deleteKeyValueSuccess(state, output) {
        state.deleteKeyValueOutput = true;
    },
    deleteKeyValueFailure(state) {
        state.deleteKeyValueOutput = false;
    },
};

export const keyValues = {
    namespaced: true,
    state,
    actions,
    mutations
};
